// Lodash
import { get } from 'lodash';

// STORE ACTION AND STATE
import { Actions, ActionTypes } from './actions';
import { Actions as AuthActions, ActionTypes as AuthActionTypes } from '../../modules/auth/store/actions';
import { initialState, MasterState } from './state';

/**
 * This reducer is for store data using actions.
 * For master data store purpose.
 *
 * @author Pratik Shihora <pratik@saeculumsolutions.com>
 *
 * Notes:-
 * Date: 16/03/2020 (Pratik Shihora <pratik@saeculumsolutions.com>) initially create ruducer with few actions
 */
export function reducer(state = initialState, action: Actions | AuthActions): MasterState {
  switch (action.type) {
    // GET_MASTER COMMON METHOD
    case ActionTypes.GET_MASTER: {
      return state;
    }
    // GET_STATE_BY_COUNTRY
    case ActionTypes.GET_STATE_BY_COUNTRY_SUCCESS: {
      if (action.response && action.response.data && action.response.data.data && action.response.data.data.states) {
        return {
          ...state,
          stateLookUp: {
            ...state.stateLookUp,
            [action.response.action.country_id]: action.response.data.data.states,
          },
        };
      } else {
        return state;
      }
    }
    // GET_MASTER_SUCCESS COMMON METHOD
    case ActionTypes.GET_MASTER_SUCCESS: {
      // commonly store and handle all master modules
      return {
        ...state,
        [action.response.common.STATE]: get(action.response.data, action.response.common.API_RESPONSE),
      };
    }

    // CLEAR_REDUCER METHOD ON LOGOUT
    case AuthActionTypes.CLEAR_REDUCER: {
      console.log('logout')
      return initialState;
    }
    // DEFAULT
    default:
      return state;
  }
}
